import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {AnalyticsDashboardPage} from './pages/AnalyticsDashboardPage';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {usePermissionsFailureGuard} from '../../hooks/usePermissionsFailureGuard.ts';
import {rbacActions} from "../../config/rbac/actions.ts";

// Single-page module today: analytics has one dashboard and no add/edit pages.
// It still uses the module/* layout shape so the route carries its own RBAC gate
// (GetAnalytics) rather than relying on the navbar to hide the link (FNP-1119).
export const AnalyticsLayout = () => {

    // Interim until FNP-1749: a failed check shows the error page, never a redirect.
    usePermissionsFailureGuard();

    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.GetAnalytics) ? (
                        <AnalyticsDashboardPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
        </Routes>
    );
};
